import React, { useContext, useEffect} from 'react';
import Date from '../../../../ui/Date';
import LeftRightSplit from '../../../../ui/LeftRightSplit';
import SecondaryButton from '../../../../ui/SecondaryButton';
import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import TextBox from '../../../../ui/TextBox';
import Label from '../../../../ui/Label';
import { AmsVoyage } from '../../../../fms.data/models/AmsVoyage';
import { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import ApplicationContext from '../../../../ApplicationContext';
import _ from 'lodash';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';

interface ViewVoyageStorageKeys {
  modelStorage: string,
};

interface ViewVoyageParams {
  id: string | undefined,
  onPopupClose?: () => void,
};

interface ViewVoyageLoadedDetailsViewParams {
  voyage: AmsVoyage,
  onPopupClose?: () => void
};

function getViewVoyageStorageKeys(): ViewVoyageStorageKeys {
  return {modelStorage: 'oi-ams-voyage'}
}

function ViewVoyageImpl(params: ViewVoyageParams) {
  const {id, onPopupClose} = params;
  const {modelStorage} = getViewVoyageStorageKeys();
  const [inStorage, setInStorage, removeVoyageFromStorage] = useTypedFastStorage<AmsVoyage>(modelStorage, null);
  const appContext = useContext(ApplicationContext);

  useFunctionKeys({onEsc: cancel});

  function cancel() {
    if(onPopupClose) onPopupClose();
    return true;
  }
  
  useEffect(() => {
    initialize();
    return () => {
      removeVoyageFromStorage()
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
);

async function loadExisting() {
  const apiResult = await appContext.api.getAmsVessel(id);
  if(apiResult && apiResult.success) {
    let data: AmsVoyage = new AmsVoyage(apiResult.result);
    return data;
  }
  return {}
}

async function initialize() {
  const data = await loadExisting();
  setInStorage(_.cloneDeep(data));
}

if (!inStorage) {
  return null;
}

  return (
    <ViewVoyageImplInitializedImpl 
      voyage={inStorage}
      onPopupClose={params.onPopupClose}
    />
  );
}

function ViewVoyageImplInitializedImpl({
  voyage,
  onPopupClose
}: ViewVoyageLoadedDetailsViewParams) {

  return (
    <div className='report-popup'>
      <div style={{display: 'flex'}}>
        <div style={{width: '320px'}}>
          <InlineInputControlRow mode="smaller-2x" smallMargin label="AMS User">
            <div style={{width: '70px'}}>
              <TextBox value={voyage.userName} disabled />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow mode="smaller-2x" smallMargin label="Vessel">
            <TextBox value={voyage.vesselName} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow mode="smaller-2x" smallMargin label="Voyage">
            <div style={{width: '70px'}}>
              <TextBox value={voyage.voyage} disabled />
            </div>
          </InlineInputControlRow>
        </div>

        <div style={{width: '320px', marginLeft: '40px'}}>
          <InlineInputControlRow mode="smaller-2x" smallMargin label="Port of Loading">
            <LeftRightSplit
              leftSize="70px"
              rightSize="calc(100% - 70px)"
              left={<TextBox value={voyage.loadPort} disabled />}
              right={<TextBox value={voyage.lPortName} disabled />}
            />
          </InlineInputControlRow>

          <InlineInputControlRow mode="smaller-2x" smallMargin label="Port of Discharge">
            <LeftRightSplit
              leftSize="70px"
              rightSize="calc(100% - 70px)"
              left={<TextBox value={voyage.lastPort} disabled />}
              right={<TextBox value={voyage.fPortName} disabled />}
            />
          </InlineInputControlRow>

          <InlineInputControlRow mode="smaller-2x" smallMargin label="First US Port">
            <LeftRightSplit
              leftSize="70px"
              rightSize="calc(100% - 70px)"
              left={<TextBox value={voyage.firstPort} disabled />}
              right={<TextBox value={voyage.uPortName} disabled />}
            />
          </InlineInputControlRow>

          <InlineInputControlRow mode="smaller-2x" smallMargin label="Final Destination">
            <LeftRightSplit
              leftSize="70px"
              rightSize="calc(100% - 70px)"
              left={<TextBox value="" disabled />}
              right={<TextBox value="" disabled />}
            />
          </InlineInputControlRow>

          <InlineInputControlRow mode="smaller-2x" smallMargin label="Load ETD">
            <div style={{display: 'flex'}}>
              <div style={{width: '70px'}}>
                <Date value={voyage.loadETD} disabled hideIcon />
              </div>
              <div style={{width: '70px'}}>
                &nbsp;<Label label="Foreign ETD" />
              </div>
              <div style={{width: '70px'}}>
                <Date value={voyage.lastETD} disabled hideIcon />
              </div>
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow mode="smaller-2x" smallMargin label="First US ETA">
            <div style={{width: '70px'}}>
              <Date value={voyage.firstETA} disabled hideIcon />
            </div>
          </InlineInputControlRow>
        </div>

      </div>

      <div className='clearfix'/>
      <div className='report-footer'>
        <SecondaryButton
          size="regular"
          name='voyage-detail-cancel-button'
          onClick={onPopupClose}>
          CANCEL
        </SecondaryButton>
      </div>
    </div>
  );
}

const ViewVoyage = ({onPopupClose, selectedElementId}: { onPopupClose?: () => void, selectedElementId: string }) => {

  return (
    <ViewVoyageImpl id={selectedElementId} onPopupClose={onPopupClose} key={`viewVoyage-details`}/>
  );
};
export default ViewVoyage;
